































































helpers = require('../../helpers.coffee')
summernote = require('../../libraries/summernote.coffee')

view_model =
  data: ->
    file: null
    user: {}
    timezones: [value: null, text: 'Carregando...']
    loading: false

  methods:
    submit: ->
      @$validator.validateAll(@user).then (success) =>
        if @$signature.summernote('code') != @user.signature
          @openModalSignature()
        else
          @update(false)

    updateUser: ->
      Loader.on()
      @usersResource.update(@updateUserSuccess, @handleApiErrors, @buildFormData())

    updateUserSuccess: (data, response) ->
      Loader.off()
      @trackIntercomEvent(data.user)
      Session.updateCurrentUser response.body.user
      @user = Session.currentUserCopy()
      alertify.success 'Perfil salvo com sucesso'

    buildFormData: ->
      form_data = new FormData()
      form_data.append('picture', @file) if @file
      form_data.append('id', @user.id)
      form_data.append('name', @user.name)
      form_data.append('timezone', @user.timezone)
      form_data.append('signature', @user.signature)
      if @user.update_all_signatures
        form_data.append('update_all_signatures', @user.update_all_signatures)
      form_data

    fileInput: (event) ->
      files = event.target.files || event.dataTransfer.files
      if files && files[0]
        @file = files[0]
        @previewPicture()

    loadTimezones: ->
      @usersResource.timezones(@loadTimezonesSuccess)

    loadTimezonesSuccess: (response) ->
      @timezones = [value: null, text: 'Selecione um fuso horário']
      for timezone in response.body
        @timezones.push(value: timezone, text: timezone)

    loadSignatureSummernote: ->
      @$signature = jQuery '#signature'
      summernote(@$signature)
      @$signature.summernote('code', @user.signature)

    ensureSignature: ->
      signature = @$signature.summernote('code')
      @user.signature = if signature != '<p><br></p>' then signature else ''

    previewPicture: ->
      reader = new FileReader()
      reader.onload = (e) ->
        jQuery('.user-picture').css('background-image', "url(#{e.target.result})");
      reader.readAsDataURL(@file);

    trackIntercomEvent: (user) ->
      metadata = [
        { attribute: 'name', key: 'Nome', function: 'changedFromTo' },
        { attribute: 'timezone', key: 'Fuso horário', function: 'changedFromTo' },
        { attribute: 'signature', key: 'Assinatura atualizada', function: 'isChanged' },
        { attribute: 'signature', key: 'Quantidade de imagens na assinatura', function: 'htmlImgTagQuantityDiff' },
        { attribute: 'signature', key: 'Quantidade de hiperlinks assinatura', function: 'htmlATagQuantityDiff' },
        { attribute: 'picture_url', key: 'Foto de perfil alterada', function: 'isChanged' },
      ]
      IntercomCtrl.trackEventMetadata('Perfil atualizado', metadata, Session.current_user, user)

    openModalSignature: ->
      EventsBus.$emit('confirm-modal-show', id: 'atualizar-assinatura-confirmation-modal')

    update: (args) ->
      if args
        @user.update_all_signatures = true

      @ensureSignature()
      @updateUser()

  mounted: ->
    @usersResource = new UsersResource()
    @user = Session.currentUserCopy()
    @loadSignatureSummernote()
    @loadTimezones()

  beforeDestroy: ->
    @$signature.summernote('destroy')

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/profile.vue